var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAluminumBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aluminum-bag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "budicon-aluminum-bag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H18V2.5A2.5,2.5,0,0,0,15.5,0h-6A2.5,2.5,0,0,0,7,2.5V4H1.5A1.5,1.5,0,0,0,0,5.5v16A1.5,1.5,0,0,0,1.5,23h22A1.5,1.5,0,0,0,25,21.5V5.5A1.5,1.5,0,0,0,23.5,4ZM8,2.5A1.5,1.5,0,0,1,9.5,1h6A1.5,1.5,0,0,1,17,2.5V4H8Zm16,19a.5.5,0,0,1-.5.5H1.5a.5.5,0,0,1-.5-.5V5.5A.5.5,0,0,1,1.5,5h22a.5.5,0,0,1,.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,9H4.5a.5.5,0,0,0,0,1h16a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,13H4.5a.5.5,0,0,0,0,1h16a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,17H4.5a.5.5,0,0,0,0,1h16a.5.5,0,0,0,0-1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAluminumBag);
export default __webpack_public_path__ + "static/media/aluminum-bag.44a3a9c565bad5aa788e9605752cb05d.svg";
export { ForwardRef as ReactComponent };